<template>
  <div>
    <section class="main widgets bgform">
      <div class="figuras negro">
        <div class="container loginwidget">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12">
              <!-- <div class="row">
                <div class="col-12 text-center white fG pb-3">
                  <span class="bold">Para comenzar,</span> inicia sesión.
                </div>
                <div class="col-12 text-center white fG pb-3">
                  <a href class="btn btnfb">
                    <i class="fab fa-facebook-square"></i> Inicia con
                    <span class="bold">Facebook</span>
                  </a>
                </div>
                <div class="col-12 text-center white fG pb-3">ó</div>
              </div>-->
              <div class="row pb-3">
                <div class="formulario col-12 pt-5 px-5 pb-1 widgets">
                  <form
                    method="post"
                    @submit="submitFormulario($event)"
                    v-if="paso == 1"
                  >
                    <label>
                      <input
                        type="text"
                        class="roboto w400"
                        v-model="email"
                        maxlength="100"
                        placeholder="Email"
                        required
                      />
                    </label>

                    <label class="m-0">
                      <input
                        type="password"
                        class="roboto w400"
                        v-model="password"
                        maxlength="100"
                        placeholder="Contraseña"
                        required
                      />
                    </label>

                    <div class="d-flex pt-1 pb-3 mx-0 halfedbtns">
                      <div class="left">
                        <div class="row">
                          <div class="col-12">
                            <button
                              type="button"
                              class="btn btnazul mt-2 fC"
                              @click="abreLinkExterno(url)"
                            >
                              Crea una cuenta
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="left">
                        <div class="text-center pt-2">
                          <button
                            type="submit"
                            class="submit btn btnsup4 fC bold"
                          >
                            Entrar
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>

                  <form
                    method="post"
                    @submit="submitVerificacion($event)"
                    v-if="paso == 2"
                  >
                    <label>
                      <input
                        type="text"
                        v-model="form2.codigo"
                        maxlength="100"
                        placeholder="Código de verificación"
                        required
                      />
                    </label>

                    <div class="row pb-3">
                      <div class="col-6">
                        <!-- <div class="row">
                          <div class="col-12">
                            <router-link to="/" class="gris">¿Ya tienes cuenta? Ingresa aquí.</router-link>
                          </div>
                        </div>-->
                      </div>
                      <div class="col-6">
                        <div class="text-center pt-1">
                          <button
                            type="submit"
                            class="submit btn btnsup4 w-100"
                          >
                            Verificar
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="col-12 pb-4 white text-center">
                  {{ this.mensaje }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      mensaje: "",
      email: "",
      password: "",
      paso: 1,
      form2: {
        email: "",
        codigo: "",
      },
      arktrid: "",
      url: "",
    };
  },
  mounted: function () {

    window.fbq('track', 'ViewContent', {producto : "mdlp", seccion: "home"});

    AOS.init();
    try {
      if (this.$route.query.arktrid != undefined && this.$route.query.arktrid != '')
        this.arktrid = this.$route.query.arktrid;
    } catch (e) {
      //algo
      this.arktrid = "";
    }
    this.url =
      "https://saboryestilo.com.mx/registro-maestros-de-la-parrilla-2021/?arktrid=" +
      this.arktrid;
  },
  components: {},
  methods: {
    abreLinkExterno(url) {
      this.$gtag.event("Click crear cuenta", {
        event_category: "MDLP",
      });
      window.top.location = url;
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.email,
        password: this.password,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "login.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              //this.$store.state.user = this.$cookie.get("useracademiadigital");

              localStorage.setItem("useracademiadigital", JSON.stringify(res.user));
              this.$store.state.user = JSON.stringify(res.user);

              this.$gtag.event("Login en aplicación", {
                event_category: "MDLP",
              });

              window.top.location =
                "https://saboryestilo.com.mx/maestros-de-la-parrilla-2020/";
            } else if (res.status == "notok") {
              this.mensaje = res.msg;

              if (res.verificacion == 0) {
                this.paso = 2;
                this.form2.email = this.email;
                this.mensaje = res.msg;
              }
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);

            this.mensaje =
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.";
          }
        );
    },
    submitVerificacion(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        email: this.email,
        codigo_de_verificacion: this.form2.codigo,
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      console.log(JSON.stringify(qData));

      this.$http
        .post(this.$store.state.baseurl + "alta-verificacion.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            this.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
              //this.$store.state.user = this.$cookie.get("useracademiadigital");

              localStorage.setItem("useracademiadigital", JSON.stringify(res.user));
              this.$store.state.user = JSON.stringify(res.user);

              this.$gtag.event("Verificó cuenta", {
                event_category: "MDLP",
              });
              this.$gtag.event("Login en aplicación", {
                event_category: "MDLP",
              });

              window.top.location =
                "https://saboryestilo.com.mx/maestros-de-la-parrilla-2020/";
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
  },
};
</script>

